// extracted by mini-css-extract-plugin
module.exports = {"root":"checkbox-content_root__jrg45"};